import { jsx as _jsx } from "react/jsx-runtime";
import { Result } from 'antd';
import Animate from 'rc-animate';
import { FormattedMessage } from 'react-intl';
export const ErrorBoundaryFallback = ()=>{
    const Exception = ()=>/*#__PURE__*/ _jsx(Result, {
            status: "403",
            title: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "toolbar.info_panel_error"
            }),
            subTitle: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "error"
            }),
            style: {
                width: '100vw'
            }
        });
    return /*#__PURE__*/ _jsx(Animate, {
        transitionName: "fade",
        transitionAppear: true,
        children: /*#__PURE__*/ _jsx(Exception, {})
    });
};
